<!--
 * @Description:市场营销-线索管理联系人，投放记录联系人  props edisabled 不可以编辑
   /zbu/clueTracking/view 线索跟踪详情
   /zbu/clueReleaseRecord/view 线索投放记录详情
   /zbu/partnerContact/view 线索管理列表详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-09-28 16:36:44
 * @LastEditors: cxh
-->
<template>
  <CosModal
    v-model:visible="visible"
    :title="disabled ? '查看' : form.id ? '编辑维护' : '新增维护'"
    class="clueMerge"
    width="670px"
    @ok="handleSubmit"
    :hideOk="disabled"
    :confirmLoading="loading"
  >
    <CosViewContent :view="disabled">
      <a-form :model="form" ref="formRef" v-if="visible">
        <a-form-item name="partnerName" label="合作伙伴名称">
          <CosInput v-model:value="form.partnerName" placeholder="请输入" :disabled="true" :view="disabled" />
        </a-form-item>
        <a-form-item
          name="partnerContactId"
          :rules="{
            required: true,
            validator: selectForNumberValidate,
            message: '请选择'
          }"
          label="对接人"
        >
          <CosSelect
            :options="dropList"
            :view="disabled"
            :fieldNames="{ label: 'name', value: 'id' }"
            v-model:value="form.partnerContactId"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item
          name="followTime"
          :rules="{
            required: true,
            message: '请选择'
          }"
          label="维护时间"
        >
          <CosInput v-model:value="form.followTime" placeholder="请输入" v-if="disabled" :view="disabled" />
          <a-date-picker
            v-else
            v-model:value="form.followTime"
            show-time
            valueFormat="YYYY/MM/DD HH:mm:ss"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item name="fileUrl" label="附件上传">
          <UploadFile v-model:value="form.fileUrl" :view="disabled" />
        </a-form-item>
        <a-form-item
          label="具体内容"
          :span="24"
          name="content"
          :rules="{
            required: true,
            message: '请输入'
          }"
        >
          <CosTextarea v-model:value="form.content" placeholder="请输入" :view="disabled" />
        </a-form-item>
      </a-form>
    </CosViewContent>
  </CosModal>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { partnerFollowRecordAdd, partnerFollowRecordEdit, partnerGetDropList } from '@/api/marketing/marketingManage'
import UploadFile from '@/components/UploadFile'
import type { PartnerManage } from '@/typings/api/marketingManage'
import { cloneDeep } from 'lodash-es'
import { selectForNumberValidate } from '@/utils/validate'
const emit = defineEmits(['success'])
defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  view: {
    type: Boolean,
    default: false
  }
})
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const dropList = ref([])
const form = ref<PartnerManage['partnerContact']>({})
const toggle = (row?: PartnerManage['partnerContact']) => {
  if (row) {
    form.value = cloneDeep(row)
    getPartnerGetDropList()
  } else {
    form.value = {}
  }
  visible.value = !visible.value
}
// 获取对接人下拉框
const getPartnerGetDropList = () => {
  partnerGetDropList({
    partnerId: form.value.partnerId
  }).then((res) => {
    dropList.value = res.data
  })
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      const { partnerName, ...other } = form.value
      if (form.value.id) {
        await partnerFollowRecordEdit(other)
        message.success('编辑成功')
        emit('success')
      } else {
        await partnerFollowRecordAdd({
          ...other
        })
        message.success('新增成功')
        emit('success', 'add')
      }
      toggle()
    } catch (error) {}
    loading.value = false
  })
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'partnerActivityFrom' }
</script>
<style lang="scss" scoped></style>
